(function ($) {
	'use strict';

	$(function () {
		const $buttons = $('[data-jobs-apply-button][data-apply-url]');
		if (!$buttons.length) return;

		function matchingButtons(jobId) {
			if (!jobId) return $('[data-jobs-apply-button]');

			return $('[data-jobs-apply-button]').filter(function () {
				return String($(this).data('job-id')) === String(jobId);
			});
		}

		function setApplied(message, jobId) {
			matchingButtons(jobId).each(function () {
				$(this)
					.addClass('is-applied')
					.prop('disabled', true)
					.removeAttr('data-apply-url')
					.html('<i class="uil uil-check-circle"></i> ' + window.___('Ви вже відгукнулися'));
			});
			$('[data-jobs-apply-message]').text(message || window.___('Роботодавець отримав ваш відгук.'));
		}

		$(document).on('click', '[data-jobs-apply-button][data-apply-url]', function () {
			const $button = $(this);
			const url = $button.data('apply-url');
			const jobId = $button.data('job-id');
			if (!url || $button.prop('disabled')) return;

			matchingButtons(jobId).filter('[data-apply-url]')
				.prop('disabled', true)
				.addClass('is-loading')
				.find('span')
				.text(window.___('Надсилаємо...'));

			$.ajax({
				url: url,
				method: 'POST',
				dataType: 'json',
				headers: {
					'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
					'Accept': 'application/json'
				}
			}).done(function (response) {
				setApplied(response.message, jobId);
			}).fail(function () {
				matchingButtons(jobId).filter('[data-apply-url]')
					.prop('disabled', false)
					.removeClass('is-loading')
					.find('span')
					.text(window.___('Відгукнутися'));
				$('[data-jobs-apply-message]').text(window.___('Не вдалося надіслати відгук. Спробуйте ще раз.'));
			});
		});
	});
})(jQuery);
